import React from "react";
import lock from "../../../assets/img/icons/lock.svg";
import greenTick from "../../../assets/img/icons/task-green.svg";
import whiteTick from "../../../assets/img/icons/task-white.svg";

// phase = [{phaseNum:1,PhaseName:"",PhaseSub:[{Subname:""}]}]
// CurrentPhase
const CreateSidebar = ({ phase, currentPhase, currentsubPhase }) => {
  return (
    <div className="CreateSidebar__back">
      {phase.map(i =>
        <div>
          <div
            className={`CreateSidebar ${i.phaseNum > currentPhase
              ? ""
              : "CreateSidebar__active"} flex items-center gap-[10px]`}
          >
            {i.phaseNum > currentPhase
              ? <div className="CreateSidebar--number center">
                  {i.phaseNum}
                </div>
              : <div className="CreateSidebar--check center">
                  <img src={whiteTick} />
                </div>}
            <h3>
              {i.PhaseName}
            </h3>
          </div>
          <div
            className={` ${i.phaseNum < currentPhase
              ? "CreateSidebar__sub--active"
              : ""} CreateSidebar__sub`}
          >
            {i.PhaseSub.map(j =>
              <div className="flex items-center gap-[8px] my-[12.5px]">
                {i.phaseNum < currentPhase || (i.phaseNum <= currentPhase && j.subphasenum <= currentsubPhase)
                  ? <div>
                      <img src={greenTick} />
                    </div>
                  : <div>
                      <img src={lock} />
                    </div>}
                <div
                  className={
                    ` ${i.phaseNum === currentPhase &&
                      j.subphasenum === currentsubPhase  ? "CreateSubname__active"
                      : ""}`
                     
                  }
                >
                  {j.Subname}
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default CreateSidebar;
